import SitePhoto from '@/components/Photo'
import { Ctas, type SectionOf } from './shared'

export default function CoverSection({ section }: { section: SectionOf<'cover'> }) {
  const [first, ...rest] = section.lines
  return (
    <>
      {/* Under the words, and under a fixed scrim so the contrast does not
          depend on the photograph. Both are `-z-10` inside the section's
          own stacking context (`isolate`, in `background()`), so neither
          can reach the page-wide gradient ribbon `Layout` paints there. */}
      {section.photo && (
        <>
          <SitePhoto
            photo={section.photo}
            priority
            sizes="100vw"
            className="absolute inset-0 -z-10 h-full w-full object-cover"
          />
          <div aria-hidden className="absolute inset-0 -z-10 bg-[hsl(var(--ink)/0.6)]" />
        </>
      )}
      <div className="mx-auto max-w-4xl text-center">
        <h1 className="text-[2.5rem] font-extrabold uppercase leading-[1.05] sm:text-6xl lg:text-7xl">
          <span className="block tracking-tight">{first}</span>
          {rest.map((line) => (
            <span key={line} className="mt-3 block tracking-[0.2em] sm:mt-5">
              {line}
            </span>
          ))}
        </h1>
        {section.sub && (
          <p className="mt-10 text-lg font-bold sm:text-xl">{section.sub}</p>
        )}
        {section.ctas?.length ? (
          <div className="flex justify-center">
            <Ctas items={section.ctas} onDark />
          </div>
        ) : null}
        {/* The reference's scroll cue. Decorative: the page below it is the
            page, and a link to it would be a link to nowhere new. */}
        <svg
          viewBox="0 0 24 24"
          aria-hidden="true"
          className="mx-auto mt-14 h-7 w-7 opacity-90"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M12 4v15M6 13l6 6 6-6" />
        </svg>
      </div>
    </>
  )
}
